import { FC } from 'react'
import { UserDetailsConsents } from 'components/User'
import { UserProtectedRoute } from 'routes'

const UserConstensDetailsPage: FC = () => {
  return (
    <UserProtectedRoute>
      <UserDetailsConsents />
    </UserProtectedRoute>
  )
}

export default UserConstensDetailsPage
